export const CommonEventTranslations = {
  EVENTS: {
    es: 'Detalle del evento',
    en: 'Event detail',
    cat: 'Detall de l`esdeveniment',
    eus: 'Ekitaldiaren xehetasunak',
    pt: 'Detalhes do evento'
  },
  COPY_LINK: {
    es: 'Copiar enlace',
    en: 'Copy link',
    cat: 'Copiar enllaç',
    eus: 'Kopiatu esteka',
    pt: 'Copiar link'
  },
  ADD_TO_CALENDAR: {
    es: 'Añadir al calendario',
    en: 'Add to calendar',
    cat: 'Añadir al calendari',
    eus: 'Ekitaldiaren gordetzeko',
    pt: 'Adicionar ao calendário'
  },
  ADDED_TO_CALENDAR: {
    es: 'Añadido',
    en: 'Added',
    cat: 'Añadit',
    eus: 'Gehituta',
    pt: 'Adicionado'
  },

  ENTER_EVENT: {
    es: 'Unirme al evento',
    en: 'Join event',
    cat: 'Unir-me al esdeveniment',
    eus: 'Ekitaldia sartu',
    pt: 'Entrar no evento'
  },
  ENTER_CLASS: {
    es: 'Unirme a la clase',
    en: 'Join class',
    cat: 'Unir-me al curs',
    eus: 'Ikastaroko sartu',
    pt: 'Entrar na aula'
  },
  START_CLASS: {
    es: 'Iniciar clase',
    en: 'Start class',
    cat: 'Iniciar curs',
    eus: 'Ikastaroko hasi',
    pt: 'Iniciar aula'
  },
  START_EVENT: {
    es: 'Iniciar evento',
    en: 'Start event',
    cat: 'Iniciar esdeveniment',
    eus: 'Ekitaldia hasi',
    pt: 'Iniciar evento'
  },
  DOCUMENTS: {
    es: 'Documentos',
    en: 'Documents',
    cat: 'Documents',
    eus: 'Dokumentuak',
    pt: 'Documentos'
  },
  EVENT_INFO: {
    es: 'Información del evento',
    en: 'Event information',
    cat: 'Informació de l`esdeveniment',
    eus: 'Ekitaldiaren informazioa',
    pt: 'Informação do evento'
  },
  EVENT_SPEAKERS: {
    es: 'Ponentes',
    en: 'Speakers',
    cat: 'Ponents',
    eus: 'Hizlariak',
    pt: 'Oradores'
  },
  COURSES: {
    es: 'Cursos y temas',
    en: 'Courses and topics',
    cat: 'Cursos i temes',
    eus: 'Ikastarok eta gaiak',
    pt: 'Cursos e temas'
  },
  ALL_SECTIONS: {
    es: 'Todos los temas',
    en: 'All topics',
    cat: 'Tots els temes',
    eus: 'Guztira',
    pt: 'Todos os temas'
  },
  COPY_LINK_SUCCESS: {
    es: 'Enlace copiado al portapapeles',
    en: 'Link copied to clipboard',
    cat: 'Enllaç copiat al portapapeles',
    eus: 'Esteka kopiatu da',
    pt: 'Link copiado para a área de transferência'
  },
  EVENT_LINK: {
    es: 'Enlace del evento',
    en: 'Event link',
    cat: 'Enllaç de l`esdeveniment',
    eus: 'Gertaeraren esteka',
    pt: 'Link do evento'
  },
  SEND: {
    es: 'Enviar',
    en: 'Send',
    cat: 'Enviar',
    eus: 'Bidali',
    pt: 'Enviar'
  },
  ATTENDEES: {
    es: 'Asistentes',
    en: 'Attendees',
    cat: 'Assistents',
    eus: 'Asistentziak',
    pt: 'Assistentes'
  },
  WHEN: {
    es: '¿Cuándo?',
    en: 'When?',
    cat: 'Quan?',
    eus: 'Noiz?',
    pt: 'Quando?'
  },
  ATTEND: {
    es: 'Asistir',
    en: 'Attend',
    cat: 'Assistir',
    eus: 'Asistitu',
    pt: 'Assistir'
  },
  SPEAKER: {
    es: 'Ponente',
    en: 'Speaker',
    cat: 'Ponent',
    eus: 'Hizlaria',
    pt: 'Palestrante'
  },
  UPLOAD_ATTACHMENT: {
    es: 'Subir archivo',
    en: 'Upload file',
    cat: 'Pujar arxiu',
    eus: 'Igo fitxategia',
    pt: 'Carregar ficheiro'
  },
  DELETE_LIVE_RECORD: {
    es: 'Eliminar grabación',
    en: 'Delete live record',
    cat: 'Eliminar enregistrament',
    eus: 'Ezabatu zuzeneko grabazioa',
    pt: 'Eliminar gravação ao vivo'
  },
  DELETE_LIVE_RECORD_CONFIRMATION: {
    es: '¿Estás seguro de eliminar esta grabación?',
    en: 'Are you sure to delete this live record?',
    cat: 'Estàs segur que vols eliminar aquest enregistrament?',
    eus: 'Ziur zaude zuzeneko grabazio hau ezabatu nahi duzula?',
    pt: 'Tem certeza que deseja eliminar esta gravação ao vivo?'
  },
  ARE_YOU_SURE_DELETE_THIS_ATTACHMENT: {
    es: '¿Estás seguro de eliminar este archivo?',
    en: 'Are you sure to delete this attachment?',
    cat: 'Estàs segur d`eliminar aquest arxiu?',
    eus: 'Ziur zaude fitxategi hau ezabatu nahi duzula?',
    pt: 'Tem certeza que deseja eliminar este ficheiro?'
  },
  ATTACHMENT_REMOVED_CORRECTLY: {
    es: 'EL archivo se ha eliminado correctamente',
    en: 'The file has been removed correctly',
    cat: 'L`arxiu s`ha eliminat correctament',
    eus: 'Fitxategia zuzen ezabatu da',
    pt: 'O ficheiro foi eliminado com sucesso'
  },
  ATTACHMENTS: {
    es: 'Archivos adjuntos',
    en: 'Attachments',
    cat: 'Adjunts',
    eus: 'Eranskinak',
    pt: 'Anexos'
  },
  LIVE_RECORDS: {
    es: 'Grabaciones en directo',
    en: 'Live recordings',
    cat: 'Enregistraments en directe',
    eus: 'Zuzeneko grabazioak',
    pt: 'Gravações ao vivo'
  },

  NO_LIVE_RECORDS_YET: {
    es: 'Aún no hay grabaciones en directo',
    en: 'There are no live recordings yet',
    cat: 'Encara no hi ha enregistraments en directe',
    eus: 'Oraindik ez dago zuzeneko grabazioik',
    pt: 'Ainda não há gravações ao vivo'
  },
  THEMES: {
    es: 'Temas',
    en: 'Themes',
    cat: 'Temes',
    eus: 'Gaiak',
    pt: 'Temas'
  },
  EVENT_DELETE: {
    es: 'Eliminar evento',
    en: 'Delete event',
    cat: 'Eliminar esdeveniment',
    eus: 'Ekitaldia ezabatu',
    pt: 'Eliminar evento'
  },
  LIVE_RECORD_DELETE_CONFIRMATION: {
    es: '¿Estás seguro de que quieres eliminar esta grabación?, esta acción es irreversible',
    en: 'Are you sure you want to delete this live record?, this action is irreversible',
    cat: 'Estàs segur que vols eliminar aquest enregistrament en directe?, aquesta acció és irreversible',
    eus: 'Ziur zaude zuzeneko grabazio hau ezabatu nahi duzula?, hau inoiz ezin da desegin',
    pt: 'Tem certeza que deseja eliminar esta gravação?, esta ação é irreversível'
  },
  CONFIRM_MODAL_EVENT_REMOVE_TITLE: {
    es: 'Eliminar evento',
    en: 'Remove event',
    cat: 'Eliminar esdeveniment',
    eus: 'Ekitaldia ezabatu',
    pt: 'Eliminar evento'
  },
  CONFIRM_MODAL_EVENT_REMOVE_CONTENT: {
    es: '¿Deseas eliminar todos los eventos recurrentes o solo este?',
    en: 'Do you want to remove all recurring events or just this one?',
    cat: 'Vols eliminar tots els esdeveniments recurrents o només aquest?',
    eus: 'Ekitaldi errepikatzaile guztiak ezabatu nahi dituzu edo bakarrik hau?',
    pt: 'Quer eliminar todos os eventos recorrentes ou apenas este?'
  },
  CONFIRM_MODAL_EVENT_REMOVE_ALL_TEXT: {
    es: 'Todos los eventos',
    en: 'All events',
    cat: 'Tots els esdeveniments',
    eus: 'Ekitaldi guztiak',
    pt: 'Todos os eventos'
  },
  CONFIRM_MODAL_EVENT_REMOVE_THIS_TEXT: {
    es: 'Este evento',
    en: 'This event',
    cat: 'Aquest esdeveniment',
    eus: 'Ekitaldi hau',
    pt: 'Este evento'
  },
  EDIT_NAME: {
    es: 'Editar nombre',
    en: 'Edit name',
    cat: 'Editar nom',
    eus: 'Izen aldatu',
    pt: 'Editar nome'
  },
  LIVE_RECORD_NAME_PLACEHOLDER: {
    es: 'Nombre de la grabación',
    en: 'Live recording name',
    cat: 'Nom de l`enregistrament en directe',
    eus: 'Zuzeneko grabazioaren izena',
    pt: 'Nome da gravação ao vivo'
  },
  NO_COMMENTS_YET: {
    es: 'No hay comentarios',
    en: 'No comments yet',
    cat: 'Encara no hi ha comentaris',
    eus: 'Ez dago iruzkinik',
    pt: 'Ainda não há comentários'
  },
  BE_FIRST_TO_COMMENT: {
    es: 'Sé el primero en comentar.',
    en: 'Be the first to comment.',
    cat: 'Sé el primer a comentar.',
    eus: 'Izan zaitez lehena iruzkintzen.',
    pt: 'Seja o primeiro a comentar.'
  },
  COMMENT_SOMETHING: {
    es: 'Escribir un comentario',
    en: 'Write a comment',
    cat: 'Escriu un comentari',
    eus: 'Ikusi bat',
    pt: 'Escreva um comentário'
  },
  CANCEL_MESSAGE: {
    es: 'Cancelar comentario',
    en: 'Cancel comment',
    cat: 'Cancel·lar comentari',
    eus: 'Ezabatu iruzkina',
    pt: 'Cancelar comentário'
  },
  WRITE_YOUR_MESSAGE: {
    es: 'Escribe tu comentario o pregunta',
    en: 'Write your comment or question',
    cat: 'Escriu el teu comentari o pregunta',
    eus: 'Idatzi zure iruzkina edo galdera',
    pt: 'Escreva o seu comentário ou pergunta'
  },

  MESSAGE_TIPS: {
    es: 'Tips para escribir comentarios',
    en: 'Tips for writing comments',
    cat: 'Punts per escriure comentaris',
    eus: 'Iruzkin idatzeko pautak',
    pt: 'Dicas para escrever comentários'
  },
  MESSAGE_TIPS_TOOLTIP: {
    es: 'Sé claro y específico, evita las ambigüedades. Utiliza un lenguaje sencillo y correcto, y no preguntes varias cosas a la vez.',
    en: 'Be clear and specific, avoid ambiguities. Use simple and correct language, and do not ask several things at once.',
    cat: 'Sigues clar i específic, evita les ambigüitats. Utilitza un llenguatge senzill i correcte, i no preguntis diverses coses alhora.',
    eus: 'Argi eta zehatza, ambiguitateak saihestuz. Hizkera sinple eta zuzena erabili, eta ez galderik ezazu hainbeste.',
    pt: 'Seja claro e específico, evite ambiguidades. Utilize um idioma simples e correto, e não faça várias perguntas ao mesmo tempo.'
  },
  MOST_USEFUL: {
    es: 'Más votados',
    en: 'Most voted',
    cat: 'Més votats',
    eus: 'Eskubideena',
    pt: 'Mais votados'
  },
  MOST_RECENT: {
    es: 'Más reciente',
    en: 'Most recent',
    cat: 'Més recent',
    eus: 'Azkena',
    pt: 'Mais recente'
  },
  COMMENTS: {
    es: 'Comentarios',
    en: 'Comments',
    cat: 'Comentaris',
    eus: 'Iruzkinak',
    pt: 'Comentários'
  },
  EVENT_CLASS_RECORD: {
    es: '📹 Grabaciones en directo',
    en: '📹 Live recordings',
    cat: '📹 Enregistraments en directe',
    eus: '📹 Zuzeneko grabazioak',
    pt: '📹 Gravações ao vivo'
  },
  CLASS_RECORD_SUBMITTING: {
    es: 'Clase en directo finalizada. La grabación se subirá en unos minutos.',
    en: 'Live class finished. The recording will be uploaded in a few minutes.',
    cat: 'Aula en directe finalitzada. L`enregistrament es pujarà en uns minuts.',
    eus: 'Ikastaroko zuzeneko grabazioa amaitu da. Zuzeneko grabazioa igo egingo da minutu batzuetan.',
    pt: 'Aula ao vivo finalizada. A gravação será enviada em alguns minutos.'
  },
  CLASS_RECORD_VISUALIZATIONS: {
    es: '{{views}} visualizaciones · Hace {{when}}',
    en: '{{views}} visualizations · {{when}}',
    cat: '{{views}} visualitzacions · {{when}}',
    eus: '{{views}} ikusgaiak · {{when}}',
    pt: '{{views}} visualizações · {{when}}'
  },
  VIEWED: {
    es: 'Visto',
    en: 'Viewed',
    cat: 'Vist',
    eus: 'Ikusi da',
    pt: 'Visto'
  },
  LEAVE_CLASS: {
    es: 'Salir de la clase',
    en: 'Leave class',
    cat: 'Abandonar el curs',
    eus: 'Ikastarok utzi',
    pt: 'Abandonar aula'
  },
  ARE_YOU_SURE_TO_LEAVE_CLASS: {
    es: '¿Estás seguro que quieres salir de la clase?',
    en: 'Are you sure you want to leave the class?',
    cat: 'Estàs segur que vols abandonar el curs?',
    eus: 'Ziur zaude ikastaroko utzi nahi duzula?',
    pt: 'Tem certeza que deseja sair da aula?'
  },
  LIVE_CLASS_VOTE_SEND: {
    es: 'Enviar',
    en: 'Send',
    cat: 'Enviar',
    eus: 'Bidali',
    pt: 'Enviar'
  },
  LIVE_CLASS_VOTE_CLASS_RATING_TITLE: {
    es: '¿Qué te ha parecido la clase?',
    en: 'How did you like the class?',
    cat: 'Què t`ha agradat el curs?',
    eus: 'Zer iruditu zaizu klasea?',
    pt: 'Como você gostou da aula?'
  },
  LIVE_CLASS_VOTE_CLASS_RATING_LIKE: {
    es: 'Me encantó',
    en: 'I loved it',
    cat: 'M`encantà',
    eus: 'Maite nuen',
    pt: 'Gostei muito'
  },
  LIVE_CLASS_VOTE_CLASS_RATING_DISLIKE: {
    es: 'No me gustó',
    en: 'I didn`t like it',
    cat: 'No m`encantà',
    eus: 'Ez zait gustatu',
    pt: 'Não gostei'
  },
  LIVE_CLASS_VOTE_TEACHER_RATING_TITLE: {
    es: '¿Cómo valoras al profe?',
    en: 'How do you rate the teacher?',
    cat: 'Què valoras el professor?',
    eus: 'Nola baloratzen duzu irakaslea?',
    pt: 'Como você avalia o professor?'
  },
  LIVE_CLASS_VOTE_CLASS_QUALITY_TITLE: {
    es: '¿Qué tal la calidad del audio y el vídeo?',
    en: 'How do you rate the audio and video quality?',
    cat: 'Què valoras la qualitat de l`àudio i el vídeo?',
    eus: 'Nolakoa da audio eta bideoaren kalitatea?',
    pt: 'Como você avalia a qualidade do áudio e do vídeo?'
  },
  LIVE_CLASS_VOTE_CLASS_COMMENT_TITLE: {
    es: '¿Algo que destacar o mejorar de la clase?',
    en: 'Anything to highlight or improve about the class?',
    cat: 'Alguna cosa a destacar o millorar del curs?',
    eus: 'Zerbait nabarmendu edo hobetzeko klasetik?',
    pt: 'Algo para destacar ou melhorar da aula?'
  },
  LIVE_CLASS_VOTE_CLASS_COMMENT_PLACEHOLDER: {
    es: 'Escribe aquí...',
    en: 'Write here...',
    cat: 'Escriu aquí...',
    eus: 'Idatzi hemen...',
    pt: 'Escreva aqui...'
  },
  LIVE_CLASS_VOTE_BACK: {
    es: 'Atrás',
    en: 'Back',
    cat: 'Tornar',
    eus: 'Itzuli',
    pt: 'Voltar'
  },
  RECORDS: {
    es: 'Grabaciones',
    en: 'Records',
    cat: 'Grabacions',
    eus: 'Grabazioak',
    pt: 'Gravações'
  },
  RECORDED_PARTICIPANTS_DRAWER_TITLE: {
    es: '{{count}} visualizaciones',
    en: '{{count}} views',
    cat: '{{count}} visualitzacions',
    eus: '{{count}} ikusgaiak',
    pt: '{{count}} visualizações'
  },
  CONFIRM_MODAL_EVENT_REMOVE_CANCEL_TEXT: {
    es: 'Cancelar',
    en: 'Cancel',
    cat: 'Cancel·lar',
    eus: 'Ezabatu',
    pt: 'Cancelar'
  },
  CONFIRM_MODAL_EVENT_REMOVE_OK_TEXT: {
    es: 'Eliminar',
    en: 'Remove',
    cat: 'Eliminar',
    eus: 'Ezabatu',
    pt: 'Eliminar'
  },
  NO_COMMENTS: {
    es: 'No hay comentarios',
    en: 'No comments',
    cat: 'No hi ha comentaris',
    eus: 'Ez dago iruzkinik',
    pt: 'Não há comentários'
  },
  NO_COMMENTS_DESCRIPTION: {
    es: 'Esta clase no tiene comentarios',
    en: 'This class has no comments',
    cat: 'Aquesta classe no té comentaris',
    eus: 'Ikastaroko iruzkinik ez',
    pt: 'Esta aula não tem comentários'
  }
};
